const advisorCustom = {
  displayField: 'name',
  name: 'Advisor Custom',
  description: 'This is a custom Advisor not available from the API',
  fields: [
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'name',
      name: 'Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'advisorCustom',
    version: 4,
    updatedAt: '2023-08-02T21:15:03.794Z'
  }
};
export default advisorCustom;